import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Stack, styled } from "@mui/material";
import { ArrowBack, Download, Info } from "@mui/icons-material";
import Button from "../../components/Button";
import { downloadFileFromArray } from "../../helpers/Utils";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useInvoiceV2Flag } from "./hooks/useInvoiceV2Flag";

const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Gap = () => <Box height={24} />;

const handleDownload = (errors) => {
  downloadFileFromArray(errors, "errors");
};

const PostUpload = () => {
  const location = useLocation();
  const naviagate = useNavigate();
  const isMobileViewport = useIsMobile();
  const { isV2 } = useInvoiceV2Flag();
  const isMobile = isV2 && isMobileViewport;
  const mobileFlexSx = isMobile ? { px: 2, py: 3, height: "auto", minHeight: "100vh" } : undefined;
  const { data } = location.state || {};
  if (!data)
    return (
      <FlexBox>
        <div>No data found</div>
      </FlexBox>
    );
  const status = Object.keys(data.error_map)?.length ? "error" : "success";
  if (status === "error")
    return (
      <FlexBox sx={mobileFlexSx}>
        <div style={{ textAlign: "center", width: isMobile ? "100%" : undefined }} fontSize="large">
          <Info color={"error"} sx={{ fontSize: isMobile ? "32px" : "40px" }} />
          <Gap />
          <div className="ft-20" style={{ fontWeight: 700 }}>
            {Object.keys(data.error_map)?.length} Errors Found
          </div>
          <Gap />
          <div className="ft-14" style={{ fontWeight: 500 }}>
            Please download the errors list and re-upload the csv with
            corrections.
          </div>
          <Gap />
          <Button
            type="primary"
            fillStyle="filled"
            style={isMobile ? { width: "100%" } : undefined}
            onClick={() => handleDownload(data.error_rows)}
          >
            <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"center"}>
              <Download />
              Download Error CSV
            </Stack>
          </Button>
          <Gap />
          <div className="table-responsive" style={{ width: isMobile ? "100%" : "95vw", overflowX: "auto" }}>
            <table className="table block">
              <thead>
                <tr>
                  <th className="ft-12">Invoice Number</th>
                  <th className="ft-12">Errors</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(data.error_map).map(([key, value]) => {
                  console.log(key, value);
                  return (
                    <tr key={key}>
                      <td>{key}</td>
                      <td>
                        {value.map((error_row, index) => (
                          <div key={error_row}>{`${
                            index + 1
                          }. ${error_row}`}</div>
                        ))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </FlexBox>
    );
  if (status === "success")
    return (
      <FlexBox sx={mobileFlexSx}>
        <div style={{ textAlign: "center", width: isMobile ? "100%" : undefined }}>
          <img
            src={require("./assets/done.png")}
            height={isMobile ? 64 : 100}
            width={isMobile ? 64 : 100}
            alt="success"
          />
          <Box height={24}></Box>
          <div className="ft-20" style={{ fontWeight: 700 }}>
            Successfully uploaded
          </div>
          <Box height={16}></Box>
          <div className="ft-14" style={{ fontWeight: 500 }}>
            {data.successful_uploads} invoices uploaded successfully. View the
            invoices for the POs from the home page.
          </div>
          <Box height={24}></Box>
          <Button
            type="primary"
            fillStyle="filled"
            style={isMobile ? { width: "100%" } : undefined}
            onClick={() => naviagate("/dashboard/invoice-management")}
          >
            <Stack direction={"row"} gap={2} alignItems={"center"} justifyContent={"center"}>
              <ArrowBack />
              Go to Home Page
            </Stack>
          </Button>
        </div>
      </FlexBox>
    );
  return <div>No data available</div>;
};

export default PostUpload;
